import wixAnimations from 'wix-animations'

import { getAllCertifications } from 'backend/certifications/services/certification'
import sortBy from 'lodash/sortBy'

$w.onReady(function () {
    loadCertifications()
    initiatePageInteractions()
});

const initiatePageInteractions = () => {
    $w('#exploreCertification').onClick(() => {
        $w('#certificationsSectionStart').scrollTo()
    })
    // $w('#exploreCourses').link = '/online-courses'
}

const loadCertifications = async () => {
    const certifications = await getAllCertifications()
    $w('#certificationsRepeater').certifications = sortBy(certifications, 'order')
    // $w('#certificationsRepeater').certifications = sortBy(certifications, 'comingSoon').reverse()

    handleCollapsableFaqSections(['question1', 'question2', 'question4', 'question5', 'question6', 'question7'])
}

const handleCollapsableFaqSections = (sectionNames) => {
    let currentlyOpen = null

    sectionNames.forEach(name => {
        $w(`#${name}Strip`).onClick(() => {
            if ($w(`#${name}Content`).collapsed) {
                expandFaqSection(name)
                if (currentlyOpen) collapseFaqSection(currentlyOpen)
                currentlyOpen = name
            } else {
                collapseFaqSection(name)
                currentlyOpen = null
            }
        })
    })
}

const collapseFaqSection = (name) => {
    $w(`#${name}Content`).collapse()
    animateIcon(name, false)
}

const expandFaqSection = (name) => {
    $w(`#${name}Content`).expand()
    animateIcon(name, true)
}

const animateIcon = (name, isOpen) => {
    wixAnimations.timeline().add($w(`#${name}Icon`), [{
        rotate: (isOpen) ? 135 : 0,
        duration: 200
    }]).play()
}